/*
  Confirm dialog
*/
import { enter, leave } from 'el-transition'
import * as Turbo from '@hotwired/turbo'
import Dialog from '/libs/dialog'
import { i18n } from '/libs/i18n'

export default class Confirm extends Dialog {
  constructor(message, options = {}) {
    super(message, options)

    this.type = options.type || 'alert'
    this.continueText = options.continue || i18n.t('common.actions.continue')
    this.cancelText = options.cancel || i18n.t('common.actions.cancel')
  }

  static railsSetup() {
    Turbo.config.forms.confirm = (message, element) => {
      const options = element.dataset.confirm ? JSON.parse(element.dataset.confirm) : {}
      const confirm = new Confirm(message, options)
      return confirm.show()
    }
  }

  templateContent() {
    return `
      <div class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
        <div class="sm:flex sm:items-start">
          <div class="mx-auto flex h-12 w-12 shrink-0 items-center justify-center rounded-full ${Confirm.#templateIconBgColorClass[this.type]} sm:mx-0 sm:h-10 sm:w-10">
            ${Confirm.#templateIcon[this.type]}
          </div>
          <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
            ${this.#templateTitle()}
            <div class="mt-2">
              <p class="text-sm text-gray-500">${this.message}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
        <button type="button" data-dialog-resolve="true" class="inline-flex w-full justify-center rounded-md border border-transparent ${Confirm.#templateResolveButtonColorClasses[this.type]} px-4 py-2 text-base font-medium text-white shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2 sm:ml-3 sm:w-auto sm:text-sm">${this.continueText}</button>
        <button type="button" data-dialog-resolve="false" class="mt-3 inline-flex w-full justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-base font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm">${this.cancelText}</button>
      </div>
    `
  }

  #templateTitle() {
    if (!this.title) return ''
    return `<h3 class="text-lg font-medium leading-6 text-gray-900" id="modal-title">${this.title}</h3>`
  }

  static #templateIcon = {
    'notice': `<svg class="h-6 w-6 text-primary-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                 <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z" />
               </svg>`,
    'alert': `<svg class="h-6 w-6 text-red-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                <path stroke-linecap="round" stroke-linejoin="round" d="M12 10.5v3.75m-9.303 3.376C1.83 19.126 2.914 21 4.645 21h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 4.88c-.866-1.501-3.032-1.501-3.898 0L2.697 17.626zM12 17.25h.007v.008H12v-.008z" />
              </svg>`
  }

  static #templateIconBgColorClass = { 'notice': 'bg-primary-100', 'alert': 'bg-red-100' }

  static #templateResolveButtonColorClasses = {
    'notice': 'bg-primary-600 hover:bg-primary-700 focus:ring-primary-500',
    'alert': 'bg-red-600 hover:bg-red-700 focus:ring-red-500'
  }
}